export default "__VITE_ASSET__BbOx1LE3__"